import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
            width: '70px',
            height: '70px',
            fontSize: '28px'
        },
    },
}));

export default function LetterAvatar(props) {
    const classes = useStyles(),
        colors = [
            "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
            "#f1c40f", "#e67e22", "#e74c3c", "#f1694b", "#a60c00", "#f39c12", "#d35400", "#c0392b", "#c73292", "#911921"
        ],
        nameSplit = String(props.name).toUpperCase().split(' ');
    let initials, colorIdx;

    if (nameSplit.length === 1) {
        initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        colorIdx = initials.charCodeAt(0);
    } else {
        initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        colorIdx = initials.charCodeAt(0) + initials.codePointAt(1);
    }

    colorIdx %= 20;

    return (
        <div className={classes.root}>
            <Avatar style={{background: colors[colorIdx]}}>{initials}</Avatar>
        </div>
    );
}